
export const Playground: React.FC = () => {
    return (
        <>
            Nothing on the playground today 😕
        </>
    );
};
